import { INavigationState } from './types'

const state: INavigationState = {
    activeTopLevelIndex: null,
    secondLevelIsOpen: false,
    activeSecondLevelIndex: null,
    eventsPanelIsOpen: false,
    navData: null,
    eventsData: null,
}

export default state

